// import OBTDatePicker from './OBTDatePicker'
import OBTDatePicker from './OBTDatePickerRebuild'

export default OBTDatePicker;